import React, {useEffect} from "react";
import {Button, Form, Input} from "reactstrap";
import {addDate, formatDate, subtractDate} from "../../script/commFunc";
import {useRef} from "react";
import styled from "styled-components";
import moment from "moment";

/**
 *
 * @User : 백욱진
 * @Date : 2023.05.04
 * @file : Components/Common/CpmCommYearMonFromTo.js
 * @Desc : 데이트 픽커 컴포넌트(yyyy-MM)
 * @param {Array<string>} id - id값 (ex ['yearMonFrom', 'yearMonTo']) (부모 컴포넌트의 파라미터 key 값으로도 사용)
 * @param {object} params - 부모 컴포넌트로부터 받아온 파라미터 객체
 * @param {React.SetStateAction} setParams - 부모 컴포넌트로부터 받아온 파라미터 세터
 * @param {string} label - 라벨 명
 * @param {boolean} essential - 필수 여부
 */

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;  
  gap: 4px;
`;

const HSeparator = styled.div`
  margin: 0 3px;
  align-self: center;
`;

const CpmCommYearMonFromTo = ({
    id = [], 
    params, 
    setParams,
    label,
    essential = false,
}) => {
    const fromNm = id[0] || 'yearMonFrom'
    const toNm = id[1] || 'yearMonTo'
    const paramsFormat = "yyMM";
    const localFormat = "yyyy-MM";
    const today = formatDate(new Date(), paramsFormat);
    const yearMonFromRef = useRef(null); // yearMonFromRef element에 접근 제어
    const yearMonToRef = useRef(null); // yearMonToRef element에 접근 제어

    const onChangeYearMon = (e, type) => {
        setParams({[type === 'from' ? fromNm : toNm]: formatDate(e.target.value, paramsFormat)});
    };

    // 앞 input 월 증가
    const handleIncreaseYearMonFrom = (ref) => {
        if (moment(params[fromNm]).isSameOrBefore(params[toNm])) {
            setParams({
                [fromNm]: addDate(ref, paramsFormat, "months"),
                [toNm]: addDate(ref, paramsFormat, "months")
            });
        } else setParams({[fromNm]: addDate(ref, paramsFormat, "months")});
    };
    // 앞 input 월 감소 
    const handleDecreaseYearMonFrom = (ref) => {
        setParams({[fromNm]: subtractDate(ref, paramsFormat, "months")});
    };
    // 뒤 input 월 증가
    const handleIncreaseYearMonTo = (ref) => {
        setParams({[toNm]: addDate(ref, paramsFormat, "months")});
    };
    // 뒤 input 월 감소 
    const handleDecreaseYearMonTo = (ref) => {
        if (moment(params[fromNm]).isSameOrAfter(params[toNm])) {
            setParams({
                [fromNm]: subtractDate(ref, paramsFormat, "months"),
                [toNm]: subtractDate(ref, paramsFormat, "months")
            });
        } else setParams({[toNm]: subtractDate(ref, paramsFormat, "months")});
    };

    useEffect(() => {
        // 부모 params 초기값 세팅 
        setParams({
            [fromNm]: params[fromNm] || today,
            [toNm]: params[toNm] || today
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Wrapper>
            <Form className="d-flex  align-items-center">
                <Input
                    name={label || fromNm}
                    type="month"
                    className={`${essential && 'essential'} form-control-sm`}
                    style={{width:"120px"}}
                    value={formatDate(params[fromNm], localFormat)}
                    onChange={(e) => onChangeYearMon(e, 'from')}
                    ref={yearMonFromRef}
                    max='9999-12'
                />


                <Button
                    size="sm"
                    className="btn-icon btn-sm btn-soft-dark fs-6 rounded-1"
                    style={{borderColor:"#a9a8a8",height:"22px", width:"22px"  }}
                    onClick={() =>
                        handleDecreaseYearMonFrom(yearMonFromRef.current.props.value)
                    }
                 ><i className="ri-arrow-left-s-line"></i></Button>
                <Button
                    size="sm"
                    className="btn-icon btn-sm btn-soft-dark fs-6 rounded-1"
                    style={{borderColor:"#a9a8a8",height:"22px", width:"22px"  }}
                    onClick={() =>
                        handleIncreaseYearMonFrom(yearMonFromRef.current.props.value)
                    }
                ><i className="ri-arrow-right-s-line"></i></Button>
            </Form>

            <HSeparator>~</HSeparator>

            <div className="d-flex  align-items-center">
                <Input
                    name={label || toNm}
                    type="month"
                    style={{width:"120px"}}
                    className={`${essential && 'essential'} form-control-sm`}
                    value={formatDate(params[toNm], localFormat)}
                    onChange={(e) => onChangeYearMon(e, 'toNm')}
                    ref={yearMonToRef}
                    max='9999-12'
                />
                <Button
                    size="sm"
                    className="btn-icon btn-sm btn-soft-dark fs-6 rounded-1"
                    style={{borderColor:"#a9a8a8",height:"22px", width:"22px"  }}
                    onClick={() =>
                        handleDecreaseYearMonTo(yearMonToRef.current.props.value)
                    }
                ><i className="ri-arrow-left-s-line"></i></Button>
                <Button
                    size="sm"
                    className="btn-icon btn-sm btn-soft-dark fs-6 rounded-1"
                    style={{borderColor:"#a9a8a8",height:"22px", width:"22px"  }}
                    onClick={() =>
                        handleIncreaseYearMonTo(yearMonToRef.current.props.value)
                    }
                ><i className="ri-arrow-right-s-line"></i></Button>
            </div>
        </Wrapper>
    );
};

export default CpmCommYearMonFromTo;
